/**
 * Fixed-row-height windowing math for the records table. Hand-rolled
 * rather than adding a virtualization dependency: with a fixed row
 * height the visible slice is a pure O(1) function of the scroll offset.
 */

/** Fixed row height (px) the windowing math depends on -- kept in sync with the row's `h-7` class. */
export const RECORD_ROW_HEIGHT = 28
/** Extra rows rendered above/below the visible window so fast scrolling doesn't flash blank. */
export const RECORD_OVERSCAN = 10
/** Viewport height used until the real one is measured (and in jsdom, which has no layout). */
export const FALLBACK_VIEWPORT_HEIGHT = 480

/** The rows to render for a scroll position: `[start, end)` plus the spacer heights around them. */
export function computeWindow(
  rowCount: number,
  scrollTop: number,
  viewportHeight: number,
  rowHeight = RECORD_ROW_HEIGHT,
  overscan = RECORD_OVERSCAN,
): { start: number; end: number; padTop: number; padBottom: number } {
  const first = Math.floor(Math.max(0, scrollTop) / rowHeight)
  const visible = Math.ceil(viewportHeight / rowHeight) + 1
  const start = Math.max(0, Math.min(rowCount, first - overscan))
  const end = Math.max(start, Math.min(rowCount, first + visible + overscan))
  return { start, end, padTop: start * rowHeight, padBottom: (rowCount - end) * rowHeight }
}
